// extracted by mini-css-extract-plugin
module.exports = {"safetyCard":"m5c_-","safetyCardContent":"_31BJY"};